/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef } from 'react';
import { useEffect } from 'react';
import {
  InputGroup,
  ListGroup,
  Alert,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import './ProjectSearchInput.css'; 

const ProjectsSearchInput = ({
  selectedProject, 
  setSelectedProject, 
  label='Proyecto',
  width = "auto",
  required = false,
  allowEmptySelection = true
}) => {
  const {
    projectsByCompanies,
    projectsByCompaniesLoading,
  } = useSelector((state) => state.logisticIndicators);
  
  const [searchTerm, setSearchTerm] = useState('');
  const [showResults, setShowResults] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);
  const [lastValidSelection, setLastValidSelection] = useState(null);
  const inputRef = useRef(null);
  const resultsRef = useRef(null);

  const wrapperStyle = {
    width: width
  };

  const filteredProjects = searchTerm.length > 0 
    ? projectsByCompanies.filter(project =>
        project?.CodProyectoVector?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project?.CodProyecto?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project?.Descripcion?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : projectsByCompanies;

  const handleSearchChange = (event) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    setShowResults(true);
  };

  const handleSelectProject = (project) => {
    const projectCode = project.CodProyecto || project.CodProyectoVector;
    setSelectedProject(projectCode);
    setLastValidSelection({
      code: projectCode,
      description: project.Descripcion
    });
    setSearchTerm(project.Descripcion);
    setShowResults(false);
    setHasFocus(false);
  };

  const handleInputFocus = (e) => {
    setHasFocus(true);
    setShowResults(true);
    
    if (!allowEmptySelection && e.target) {
      setTimeout(() => {
        e.target.select();
      }, 0);
    }
  };

  const handleInputBlur = (e) => {
    if (resultsRef.current && resultsRef.current.contains(e.relatedTarget)) {
      return;
    }
    if (!allowEmptySelection && lastValidSelection) {
      const matchingProject = filteredProjects.find(project => 
        project.Descripcion === searchTerm
      );
      
      if (!matchingProject) {
        setSelectedProject(lastValidSelection.code);
        setSearchTerm(lastValidSelection.description);
      } else {
        const projectCode = matchingProject.CodProyecto || matchingProject.CodProyectoVector;
        setSelectedProject(projectCode);
        setLastValidSelection({
          code: projectCode,
          description: matchingProject.Descripcion
        });
      }
    }
    
    setHasFocus(false);
    setTimeout(() => {
      setShowResults(false);
    }, 200);
  };

  const handleClearSelection = () => {
    if (allowEmptySelection) {
      // Si se permite vacío, limpiar completamente
      setSelectedProject('');
      setSearchTerm('');
      setLastValidSelection(null);
    }
    
    setShowResults(true);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    console.log('selectedProject', selectedProject)
    if (selectedProject && projectsByCompanies.length > 0) {
      const currentProject = projectsByCompanies.find(project => 
        (project.CodProyecto || project.CodProyectoVector) === selectedProject
      );
      
      if (currentProject) {
        setLastValidSelection({
          code: selectedProject,
          description: currentProject.Descripcion
        });
        setSearchTerm(currentProject.Descripcion);
      }
    } else if (!allowEmptySelection && !selectedProject && projectsByCompanies.length > 0) {
      console.log('selectedProject', selectedProject)
      const firstProject = projectsByCompanies[0];
      const projectCode = firstProject.CodProyecto || firstProject.CodProyectoVector;
      
      setSelectedProject(projectCode);
      setLastValidSelection({
        code: projectCode,
        description: firstProject.Descripcion
      });
      setSearchTerm(firstProject.Descripcion);
    } else if (!selectedProject && allowEmptySelection) {
      setSearchTerm('');      
    }
  }, [selectedProject, projectsByCompanies, allowEmptySelection]);

  const currentSelectedProject = projectsByCompanies.find(project => 
    (project.CodProyecto || project.CodProyectoVector) === selectedProject
  );

  const displayText = hasFocus 
    ? searchTerm 
    : (currentSelectedProject?.Descripcion || searchTerm);

  const showClearButton = allowEmptySelection && (selectedProject || searchTerm);

  const shouldShowResults = showResults && 
                           !projectsByCompaniesLoading && 
                           (hasFocus || searchTerm.length > 0);

  return (
    <div 
      className={`material-select-wrapper ${(hasFocus || searchTerm || selectedProject) ? 'focused' : ''}`}
      style={wrapperStyle}
    >
      <label className="material-select-label">
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
      
      <div className="position-relative">
        <InputGroup ref={inputRef}>
          <input
            ref={inputRef}
            type="text"
            value={displayText}
            onChange={handleSearchChange}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            placeholder={projectsByCompaniesLoading ? "Cargando..." : "Buscar por código o descripción"}
            disabled={projectsByCompaniesLoading || projectsByCompanies.length === 0}
            className="form-control material-select search-input"
            style={{
              paddingRight: showClearButton ? '2.5rem' : '0.75rem',
              cursor: !allowEmptySelection ? 'pointer' : 'text'
            }}
          />
          {showClearButton && (
            <InputGroup.Text 
              style={{ 
                cursor: 'pointer',
                position: 'absolute',
                right: '0',
                zIndex: 10,
                backgroundColor: 'transparent',
                border: 'none',
                height: '100%',
                display: 'flex',
                alignItems: 'center'
              }}
              onClick={handleClearSelection}
              title="Limpiar selección"
            >
              ×
            </InputGroup.Text>
          )}
        </InputGroup>
        
        {shouldShowResults && (
          <div 
            ref={resultsRef}
            className="search-results-container"
            onMouseDown={(e) => e.preventDefault()}
          >
            <ListGroup variant="flush" className="search-results">
              {filteredProjects.length > 0 ? (
                <>
                  <ListGroup.Item className="py-2 small text-muted">
                    {searchTerm.length > 0 
                      ? `${filteredProjects.length} resultado(s) encontrado(s)` 
                      : `${filteredProjects.length} proyecto(s) disponible(s)`}
                    {!allowEmptySelection && (
                      <span className="ms-2 text-info">
                        (Selección requerida)
                      </span>
                    )}
                  </ListGroup.Item>
                  {filteredProjects.map((project) => (
                    <ListGroup.Item
                      key={project.CodProyecto || project.CodProyectoVector}
                      action
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => handleSelectProject(project)}
                      active={selectedProject === (project.CodProyecto || project.CodProyectoVector)}
                      className="py-2"
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="d-flex flex-column">
                        <span className="fw-bold small">{project.CodProyecto || project.CodProyectoVector} - {project.Descripcion}</span>
                      </div>
                    </ListGroup.Item>
                  ))}
                </>
              ) : (
                <ListGroup.Item className="py-2 text-muted fst-italic">
                  No se encontraron proyectos
                </ListGroup.Item>
              )}
            </ListGroup>
          </div>
        )}
      </div>
      
      {!projectsByCompaniesLoading && projectsByCompanies.length === 0 && (
        <Alert variant="warning" className="mt-2 small py-2">
          No hay proyectos disponibles
        </Alert>
      )}
    </div>
  );
};

export default ProjectsSearchInput;